export default __webpack_public_path__ + "assets/Error-404-Blue-66986e8.png";